import actions from "./actions";

const initState = {
  orders: [],
  loading: false,
};

export default function myMenuOrdersReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.MYMENU_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.MYMENU_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.orders,
        loading: false,
      };

    default:
      return state;
  }
}
